import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import { useQuery } from 'react-query';

import { useReportScope } from '@ge/feat-reporting/hooks/use-report-scope';
import { WidgetNames } from '@ge/feat-reporting/models/widgets';
import { EntityType, QueryKey } from '@ge/models/constants';
import { DateTimeFormats } from '@ge/models/constants';
import { Config } from '@ge/shared/data-hooks';
import { fetchReferencePeriodKpiDate } from '@ge/shared/services/kpi';

dayjs.extend(isoWeek);
export const useWidgetReferenceHistory = ({
  endDate: _endDate,
  isActive = true,
  name,
  startDate: _startDate,
}) => {
  const { siteIds, scope, scopeType } = useReportScope();
  let endDate = _endDate;
  let startDate = _startDate;
  const siteId =
    scopeType === EntityType.CONTRACT ? scope?.contractId : siteIds?.length ? siteIds[0] : '';
  const reportType = scopeType === EntityType.CONTRACT ? EntityType.CONTRACT : EntityType.SITE;

  if (name === WidgetNames.REFERENCE_PERIOD_HISTORY) {
    // Backend endpoint for this data will return an error if any future dates are passed
    const currentDate = dayjs();
    if (dayjs(endDate) > currentDate) {
      endDate = currentDate;
    }
    if (dayjs(startDate) > currentDate) {
      startDate = currentDate;
    }
  }

  const params = {
    siteId,
    reportType,
    startDate: dayjs(startDate).format(DateTimeFormats.ENDPOINT_PARAM),
    endDate: dayjs(endDate).format(DateTimeFormats.ENDPOINT_PARAM),
  };
  const {
    data: _data,
    error,
    isLoading,
  } = useQuery(
    [QueryKey.REFERENCE_PERIOD_HISTORY, params],
    () => fetchReferencePeriodKpiDate(params),
    {
      ...Config.EXECUTE_ONCE,
      enabled: isActive,
    },
  );
  return { data: _data, error, isLoading };
};
